/**
 * Labstep
 */

import { EntitySearchContext } from 'labstep-web/contexts/entity-search';
import React, { useContext } from 'react';
import type { EntitySearchContextType } from './types';

export const useEntitySearchContext = (): EntitySearchContextType => {
  const context = useContext(EntitySearchContext);
  if (!context) {
    throw new Error(
      'useEntitySearchContext must be used within a EntitySearchContextProvider',
    );
  }
  return context;
};
